export const reports: Record<string, string> = {
  'Actions': 'Actions',
  'Add a reason for this status change...':
    'Ajoutez un motif pour ce changement de statut...',
  'Assigned To': 'Affecté à',
  'Attachments': 'Pièces jointes',
  'Back to Alarms': 'Retour aux alarmes',
  'Back to Reports': 'Retour aux rapports',
  'Change Status': 'Changer le statut',
  'Close Report': 'Clôturer le rapport',
  'Closed': 'Clôturé',
  'Counts across all matching reports':
    'Totaux pour tous les rapports correspondants',
  'Delete comment': 'Supprimer le commentaire',
  'Details': 'Détails',
  'Download PDF': 'Télécharger le PDF',
  'Download Word (.docx)': 'Télécharger au format Word (.docx)',
  'In Review': 'En cours d’examen',
  'Internal': 'Interne',
  'Internal note (not visible to guard)': 'Note interne (non visible par l’agent)',
  'Last Updated': 'Dernière mise à jour',
  'Needs Info': 'Informations requises',
  'New Status': 'Nouveau statut',
  'No activity yet': 'Aucune activité pour le moment',
  'No comments yet': 'Aucun commentaire pour le moment',
  'No reports found': 'Aucun rapport trouvé',
  'Priority': 'Priorité',
  'Reason (optional)': 'Motif (facultatif)',
  'Reopen Report': 'Rouvrir le rapport',
  'Report': 'Rapport',
  'Report not found.': 'Rapport introuvable.',
  'Search reports, guards or sites': 'Rechercher des rapports, des agents ou des sites',
  'Shift': 'Vacation',
  'Start Review': 'Commencer l’examen',
  'Type': 'Type',
  'Try again': 'Réessayer',
  'Unable to load reports. Please try again.':
    'Impossible de charger les rapports. Veuillez réessayer.',
  'Update Status': 'Mettre à jour le statut',
  'Updated': 'Mis à jour',
  'Write a comment...': 'Écrivez un commentaire...',
  'commented': 'a commenté',
  'Attachment': 'Pièce jointe',
};
